import type { UserDetail } from "./user.type";
import type { UseGetOptions } from "@/hooks/queries";

import { useGet } from "@/hooks/queries";

export const useGetUser = (
  userId?: number | string,
  options?: UseGetOptions<UserDetail>
) => {
  const { data, ...queryResult } = useGet<UserDetail>("users", userId, options);

  return {
    user: data,
    ...queryResult,
  };
};
